import type { CategoryContent } from '../row.js';

export const SWISS_HISTORY: CategoryContent = {
  bscba: [
    [
      'In welk jaar hebben de drie Waldkantone traditioneel de Zwitserse Confederatie opgericht?',
      [
        '1291',
        '1315',
        '1513',
        '1648',
      ],
      0,
      'De Eed van Rütli in 1291 markeert de legendarische oprichting van de Zwitserse Confederatie door Uri, Schwyz en Unterwalden.',
    ],
    [
      'Welk verdrag erkende formeel de Zwitserse onafhankelijkheid van het Heilige Roomse Rijk in 1648?',
      [
        'Vrede van Westfalen',
        'Vrede van Augsburg',
        'Verdrag van Utrecht',
        'Vrede van Nystad',
      ],
      0,
      'De Vrede van Westfalen (1648) erkende formeel de Zwitserse onafhankelijkheid en sloot Zwitserland uit van het Heilige Roomse Rijk.',
    ],
    [
      'Wat was de Helvetische Republiek?',
      [
        'Een door Frankrijk opgelegde gecentraliseerde staat, opgericht door Napoleon in 1798',
        'Een middeleeuwse handelsfederatie langs de Rijn',
        'Een coalitie van protestantse kantons tijdens de Reformatie',
        'Een neutraal regeringscorps opgericht door de Volkenbond',
      ],
      0,
      'De Helvetische Republiek (1798-1803) was een kortstondig Frans satellietstaat die Napoleon aan Zwitserland oplegde na zijn invasie.',
    ],
    [
      'Welk Zwitsers kanton stond historisch bekend om zijn huurlingen voor buitenlandse mogendheden?',
      [
        'Zug',
        'Bern',
        'Appenzell',
        'Glarus',
      ],
      0,
      'Zug produceerde veel van de Zwitserse huurlingen die werden aangeworven door het Pausdom, Frankrijk en andere Europese mogendheden.',
    ],
    [
      'In welk jaar nam Zwitserland zijn eerste moderne federale grondwet aan?',
      [
        '1848',
        '1815',
        '1798',
        '1878',
      ],
      0,
      'De Grondwet van 1848 veranderde Zwitserland van een losse confederatie in een modern federale staat met een tweekamerstelsel.',
    ],
    [
      'Welke kerkleider leidde de Reformatie in Zürich en vormde vroegprotestantse theologie?',
      [
        'Huldrych Zwingli',
        'Martin Luther',
        'Johannes Calvijn',
        'Johannes Oecolampadius',
      ],
      0,
      'Huldrych Zwingli leidde de Reformatie van Zürich (1519-1531) en beïnvloedde protestantse theologie los van Luther en Calvijn.',
    ],
    [
      'De Vrede van Kappel (1531) stelde welk principe vast in de betrekkingen tussen kantons?',
      [
        'Elk kanton kon zijn eigen religie kiezen',
        'Alle kantons moesten de Reformatietheologie aannemen',
        'Religieuze autoriteit berustte bij de federale regering',
        'De Paus had veto-macht over kantonale wetten',
      ],
      0,
      'De Vrede van Kappel bevestigde kantonale religieuze autonomie, waardoor elk kanton zijn eigen geloof kon bepalen—basis voor Zwitserse pluralisme.',
    ],
    [
      'Wanneer stelde Zwitserland formeel een beleid van permanente neutraliteit vast?',
      [
        'In 1815, na Napoleon',
        'In 1291 met de Eed van Rütli',
        'Tijdens de Reformatie in de 16de eeuw',
        'In 1848 met de federale grondwet',
      ],
      0,
      'Na de Napoleontische Oorlogen nam Zwitserland permanente neutraliteit aan in 1815, bevestigd op het Congres van Wenen.',
    ],
    [
      'Welke stad herbergde het hoofdkwartier van de Volkenbond, wat Zwitserlands diplomatieke rol weerspiegelt?',
      [
        'Genève',
        'Bern',
        'Zürich',
        'Luzern',
      ],
      0,
      'Genève werd in 1920 hoofdkwartier van de Volkenbond, gekozen vanwege Zwitserlands neutrale status en diplomatieke expertise.',
    ],
    [
      'Wat was de betekenis van de Slag bij Marignano voor de Zwitserse militaire geschiedenis?',
      [
        'Het beëindigde Zwitserse militaire dominantie in Europa',
        'Het stelde de Zwitserse onafhankelijkheid van Oostenrijk vast',
        'Het was de oprichtingsslag van de Confederatie',
        'Het zekerde Zwitserse controle over bergpassen',
      ],
      0,
      'De Slag bij Marignano (1515), een Frans succes, markeerde het einde van Zwitserse militaire expansie naar Italië.',
    ],
    [
      'Hoeveel kantons vormden volgens traditie de originele Zwitserse Confederatie?',
      [
        'Drie (Uri, Schwyz, Unterwalden)',
        'Vier (toevoeging van Luzern)',
        'Zeven (stichters van de moderne federatie)',
        'Dertien (eindstand onder de oude confederatie)',
      ],
      0,
      'De drie Waldkantonen—Uri, Schwyz en Unterwalden—vormden de legendarische oprichtingskern van de Zwitserse Confederatie in 1291.',
    ],
    [
      'Welk kanton sloot zich als vierde bij de Confederatie aan, breidend voorbij de Waldkantonen?',
      [
        'Luzern (1332)',
        'Zürich (1351)',
        'Bern (1353)',
        'Solothurn (1481)',
      ],
      0,
      'Luzern sloot zich in 1332 aan, eerste uitbreiding buiten de originele drie kantons.',
    ],
    [
      'Welk uniek kenmerk van Zwitserse regering zat ingebakken in de Grondwet van 1848?',
      [
        'Democratie via referenda',
        'Een gekozen president',
        'Een tweekamerstelsel',
        'Verplichte militaire dienst',
      ],
      0,
      'De Grondwet van 1848 introduceerde directe democratie; de herziening van 1874 voegde het burgerinitiatief toe voor grondwetswijzigingen.',
    ],
    [
      'Welk conflict in 1847 testte de federale structuur en centralisering versus conservatieve krachten?',
      [
        'De Sonderbundoorlog',
        'De Zwingli-oorlogen',
        'De Kappel-conflicten',
        'De Zwitserse Burgeroorlog van 1798',
      ],
      0,
      'De Sonderbundoorlog (1847) zag zeven conservatieve katholieke kantons federale centralisering weerstaan; federalisten wonnen in weken.',
    ],
    [
      'Welke rol ontwikkelden Zwitserse banken die centraal werd voor Zwitserlands 20ste-eeuwse identiteit?',
      [
        'Discrete, neutrale financiële toevluchtsoorden',
        'Monopoliehouders van Alpine mineraalachtige rijkdom',
        'Hoofdkwartieren van het Europese bankkartel',
        'Handhavingsinstellingen van het pauselijke financiële systeem',
      ],
      0,
      'Zwitserse banken cultiveerden reputaties voor discretie, veiligheid en politieke neutraliteit, wat Zwitserland tot vertrouwde plaats voor financiering maakte.',
    ],
  ],
  msc: [
    [
      'Welk structuurprincipe stelde het Congres van Wenen (1815) vast voor de Zwitserse Confederatie?',
      [
        'Autonome kantons, extern verenigd, neutraliteit gegarandeerd',
        'Een gecentraliseerde federale regering met benoemde gouverneurs',
        'Religieuze uniformiteit over alle territoria',
        'Militaire ondergeschiktheid aan het Europese Concertgebouw',
      ],
      0,
      'Het settlement van 1815 herstelde soevereine kantons, formaliseerde Zwitserse permanente neutraliteit en integreerde Zwitserland in Europese machtsbalans.',
    ],
    [
      'Hoe verschilde de Acte van Mediatisatie (1803) van het centralisme van de Helvetische Republiek?',
      [
        'Semi-autonomie onder zwak centraal gezag',
        'Het schrapte alle kantonale regeringen',
        'Het verhoogde centralisatie voorbij de Helvetische Republiek',
        'Het stichtte directe democratie',
      ],
      0,
      'De Acte van Mediatisatie herstelde gedeeltelijk kantonale autonomie, met zwakker centraal gezag dan Helvetische Republiek maar sterker dan oude confederatie.',
    ],
    [
      'Wat was het ideologische conflict achter de Sonderbundoorlog voorbij religieuze deling?',
      [
        'Federalisme versus kantonale soevereiniteit',
        'Vrije handel versus protectionisme',
        'Democratische vertegenwoordiging versus aristocratie',
        'Huursoldatenwerk versus pacifisme',
      ],
      0,
      'De Sonderbundoorlog zette conservatieve katholieke kantons die lokale autonomie verdedigden af tegen federalisten voor centralisatie en liberale modernisering.',
    ],
    [
      'Welke specifieke bepaling van de Grondwet van 1848 weerspiegelde het federalistische succes?',
      [
        'Sterkere federale wetgevende macht',
        'Eliminatie van alle kantonale regeringen',
        'Verplicht protestantisme',
        'Afschaffing van lokale rechtbanken',
      ],
      0,
      'De Grondwet van 1848 centraliseerde autoriteit meer dan enig vorig settlement, wat federalistisch militair en politiek succes weerspiegelt.',
    ],
    [
      'Hoe week Huldrych Zwingli\'s theologie af van Martin Luther\'s leer over de communie?',
      [
        'Symbolische versus reële aanwezigheid in de communie',
        'Zwingli aanvaardde pauselijke autoriteit; Luther verwierp deze',
        'Zwingli verwierp vagevuur; Luther aanvaardde het',
        'Zwingli verwierp voorbestemming; Luther omarmde het',
      ],
      0,
      'Zwingli\'s symbolische interpretatie van het Avondmaal verschilde fundamenteel van Luther\'s leer over reële aanwezigheid, wat protestantse theologie splitste.',
    ],
    [
      'Wat was het gevolg van het Colloquium van Marburg (1529) voor protestantse eenheid?',
      [
        'Het blootlegde de Zwingli-Luther splitsing',
        'Het verenigde alle protestanten onder één doctrine',
        'Het leidde tot katholieke restauratie',
        'Het stelde pauselijke autoriteit vast',
      ],
      0,
      'Het Colloquium van Marburg (1529) openbaarde de Eucharistische kloof tussen Zwingli en Luther, wat protestantse eenheidsinspanningen versplinterde.',
    ],
    [
      'Hoe verschilde het kantonale kiesrecht tussen de Grondwet van 1848 en de herziening van 1874?',
      [
        'De herziening van 1874 voegde initiatief toe',
        'De Grondwet van 1848 had sterkere directe democratie',
        'De herziening van 1874 schrapte referenda',
        'Geen van beide wijzigde het kiesrecht',
      ],
      0,
      'De herziening van 1874 voegde het burgerinitiatie toe, waarmee burgers direct grondwetswijzigingen konden voorstellen—verdieping van directe democratie.',
    ],
    [
      'Welke economische verschuiving vond plaats na de teruggang van huursoldatenaanwerving na 1815?',
      [
        'Kantons schakelden over op textiel, horloges, machines',
        'Bancaire activiteiten vervingen al het huurlingeninkomen',
        'Zwitserland werd afhankelijk van landbouwexport',
        'Geen economische overgang was nodig',
      ],
      0,
      'Na 1815 dwong het verlies van huurlingeninkomsten kantons tot industrialisering: textiel, horloges, precisietools en later chocolade.',
    ],
    [
      'Welke rol speelde Alfred Escher in 19de-eeuws Zwitsers federalisme en infrastructuur?',
      [
        'Hij bevorderde Zwitserse spoorwegen',
        'Hij verzette zich tegen federaal gezag',
        'Hij leidde de Sonderbundoorlog',
        'Hij was de eerste federale president',
      ],
      0,
      'Alfred Escher bevorderde spoorwegaanleg en federaal gezag als integratietools, overkomend kantonaal particularisme door infrastructuurinvestering.',
    ],
    [
      'Hoe informeerde het principe van "kantonale religieuze autonomie" (1531) de federale structuur?',
      [
        'Het zette precedent voor regionale autonomie in bestuur',
        'Het gold alleen voor religieuze aangelegenheden, niet politiek federalisme',
        'Het werd in 1848 afgeschaft',
        'Het creëerde religieuze monarchie',
      ],
      0,
      'Het Kappel-principe—kantonale religieuze zelfbeschikking—werd model voor federale minderhedenbescherming in latere grondwetten.',
    ],
    [
      'Wat precies stelde de Bundesbrief (1291) vast omtrent militaire en politieke verplichtingen?',
      [
        'Wederzijdse verdediging en arbitrage van geschillen',
        'Volledige politieke unie onder enkelvoudige autoriteit',
        'Religieuze uniformiteit',
        'Permanente neutraliteit',
      ],
      0,
      'De Bundesbrief stelde wederzijdse verdedigingspacten en geschillenbeslechtingsmechanismen vast, waarmeemde eerste banden van Confederatie werden gesmeed.',
    ],
    [
      'Hoe werd Zwitsers bankgeheim in de 19de eeuw geïnstitutionaliseerd?',
      [
        'Losse regels lieten weinig transparantie toe',
        'Een federale wet van 1848 mandateerde geheimhouding',
        'De Volkenbond stelde geheimhoudingsregels vast',
        'Banken werden door de regering gecreëerd',
      ],
      0,
      'Losse kantonale regelgeving en zwak federaal toezicht lieten particuliere banken floreren met discretionaire rekeningbeheer, Zwitserlands bankingfaam opbouwend.',
    ],
    [
      'Welke institutionele ontwikkeling versterkte Zwitserse neutraliteit na de Napoleontische Oorlogen?',
      [
        'Geen deelname en gewapende neutraliteit',
        'Ontwapening en vertrouwen op internationaal recht',
        'Toetreding tot internationale militaire allianties',
        'Afschaffing van het leger',
      ],
      0,
      'Na 1815 versterkte Zwitserland neutraliteit via gegarandeerde niet-belligerentie, onderhouden defensieve strijdkrachten en diplomatieke onafhankelijkheid.',
    ],
    [
      'Hoe bedreigde de federale overname van buitenlandse politiek in 1848 traditionele kantonale soevereiniteit?',
      [
        'Kantons verloren diplomatieke macht',
        'Kantons behielden alle buitenlandse politieke macht',
        'De federale regering werd verzwakt',
        'Geen verandering vond plaats',
      ],
      0,
      'De Grondwet van 1848 centraliseerde buitenlandse politiek en militaire autoriteit, kantons hun onafhankelijke diplomatieke macht ontnomen.',
    ],
    [
      'Welke historische factor maakte Genève\'s religieus radicalisme onder Calvijn onderscheidend van Zwingli\'s Zürich?',
      [
        'Calvijn was strikter dan Zwingli',
        'Zwingli was theocratischer dan Calvijn',
        'Genève herformeerde nooit',
        'Ze waren identiek',
      ],
      0,
      'Calvijn\'s Genève handhaafde strikte morele en doctrinale discipline via kerkelijke rechtbanken; Zwingli\'s Zürich volgde civieke reformatie zonder dergelijke handhaving.',
    ],
  ],
  phd: [
    [
      'Hoe weerspiegelde de legendarische datering 1291 versus het Verdrag van Brunnen (1315) middeleeuwse confederatievorming?',
      [
        'Verdediging, gevolgd door autonomie',
        '1291 stelde monarchie vast',
        'Ze zijn dezelfde gebeurtenis',
        '1315 gaat vooraf aan 1291',
      ],
      0,
      'De middeleeuwse confederatie groeide via gelaagde verdragsvorming: de defensieve alliantie van 1291 werd verdiept door het Verdrag van Brunnen in 1315.',
    ],
    [
      'Welk bewijs suggereert de Rütli Eed-narratief een 15de-eeuws construct in plaats van letterlijke 1291-gebeurtenis?',
      [
        'Het verschijnt eerst in 16de-eeuwse kronieken',
        'Het werd door Napoleon geschreven',
        'Zwitserse historici hebben het als authentiek bewezen',
        'Het verschijnt in middeleeuwse manuscripten',
      ],
      0,
      'Moderne wetenschap dateert het Rütli Eed-narratief tot Tschudi\'s 16de-eeuwse kronieken; de confederatie is gedocumenteerd, maar de eed is een heroïsche mythe.',
    ],
    [
      'Hoe hervormden het Verdrag van Winterthur (1424) en de daaropvolgende stad-kantonconflicten de confederale autoriteitsstructuren?',
      [
        'Stedelijke kantons kregen meer macht',
        'Plattelands kantons behielden absolute macht',
        'Geen structuurverandering vond plaats',
        'De confederatie ontbond zich',
      ],
      0,
      'Terwijl Zürich en Bern economisch groeiden, betwistten stedelijke kantons de hegemonie van de Waldkantonen, wat tot meer overleg dwong.',
    ],
    [
      'Welk historiografisch debat omgeeft Habsburgse druk versus interne kantonale conflicten in 1291 confederatie?',
      [
        'Interne rivaliteiten telden meer',
        'Historici zijn universeel akkoord over Habsburgse bedreiging',
        'Geen debat bestaat',
        'Habsburgse druk is ontkend',
      ],
      0,
      'Recente wetenschap benadrukt lokale geschillen en alpinehandelsroutes naast Habsburgse zorgen, wat complexe lokale stimuli suggereert.',
    ],
    [
      'Hoe week Zwingli\'s civieke reformatietheologie af van radicale Doopsgezinde theologie in zijn Zürich?',
      [
        'Zwingli tegen Doopsgezinden',
        'Zwingli was een Doopsgezinde',
        'Er was geen Doopsgezinde beweging',
        'Ze waren identiek',
      ],
      0,
      'Zwingli verdedigde de magisteriale reformatie—staatsgesponsorde hervormingen; Doopsgezinden verwierpen dit, wat leidde tot sectarische afscheiding.',
    ],
    [
      'Wat was de historiografische betekenis van het Colloquium van Marburg (1529) voor protestantse versnippering?',
      [
        'Het splitste de eenheid',
        'Het verenigde alle protestanten',
        'Het had geen betekenis',
        'Het beëindigde de Reformatie',
      ],
      0,
      'Marburg blootlegde diepe doctrinale kloven binnen het gereformeerde protestantisme, wat mogelijk verenigd verzet fragmenteerde.',
    ],
    [
      'Hoe week de code civil van de Helvetische Republiek af van Napoleons Code in toepassing?',
      [
        'Het herstelde kantonaal pluralisme',
        'Ze waren identiek',
        'De code civil werd overal aanvaard',
        'Geen juridische veranderingen vonden plaats',
      ],
      0,
      'De Helvetische Republiek legde Frans recht op, maar de terugtrekking in 1803 stelde kantons in staat om aangepaste lokale systemen te behouden.',
    ],
    [
      'Welke structuurspanning tussen directe democratie en representatief federalisme bleef van 1848 tot 1874?',
      [
        'Een klep voor kantons',
        'Geen spanning bestond',
        'Directe democratie won volledig',
        'Representatie won volledig',
      ],
      0,
      'De periode 1848-1874 zag stijgende burgerinitiatiefgebruik terwijl conservatieve kantons federale wetgeving blokkeerden.',
    ],
    [
      'Hoe verhield de teruggang van het Zwitserse huursoldatenwerk zich tot de professionalisering van Europese legers na 1815?',
      [
        'Conscriptie maakte huurlingen overbodig',
        'Huursoldatenwerk bleef onveranderd',
        'Permanente legers professionaliseerden niet',
        'Zwitserland bleef huurlingen aannemen',
      ],
      0,
      'Professionele conscriptielegers verdrukten huurcompagnieën; Zwitserlands militaire specialisatie werd onbruikbaar, economische diversificatie nodig.',
    ],
    [
      'Wat was het historiografisch debat rond Zwitserse "neutraliteit" als echte onafhankelijkheid versus opgelegde isolatie?',
      [
        'Neutraliteit paste beiden',
        'Neutraliteit was volledig echt',
        'Het was volledige isolatie',
        'Er bestaat geen debat',
      ],
      0,
      'Historici debatteren of 1815-neutraliteit Zwitserse keuze of vreemde voorkeur weerspiegelde—waarschijnlijk beide factoren.',
    ],
    [
      'Hoe herschikte Alfred Escher\'s spoorwegstrategie de kantonale autonomie via economische integratie?',
      [
        'Spoorwegen beëindigden autonomie',
        'Spoorwegen hadden geen politiek effect',
        'Escher verzette zich tegen federalisme',
        'Kantons bleven autonoom',
      ],
      0,
      'Eschers federale spoorwegvisie creëerde kantonale economische afhankelijkheden, wat lokale autonomie steeds onhoudbaarder maakte.',
    ],
    [
      'Welke onopgeloste historiografische vraag omgeeft het burgerinitiative van 1874?',
      [
        'Hervorming of een klep',
        'Het was zuiver democratisch',
        'Het was zuiver conservatief',
        'Er bestaat geen vraag',
      ],
      0,
      'Het initiatief van 1874 is gelezen als progressieve democratisering of conservatieve toegeving—historici blijven verdeeld.',
    ],
    [
      'Hoe werd Zwitsers bankgeheim wettelijk geïnstitutionaliseerd onder Artikel 47 (1934)?',
      [
        'Een wettelijke plicht',
        'Bankgeheim werd in 1848 vastgesteld',
        'Het werd nooit formaliseerd',
        'Het werd in 1934 afgeschaft',
      ],
      0,
      'Artikel 47 van de Bankwet van 1934 codificeerde geheimhouding als strafrechtelijke plicht, en institutionaliseerde zo een kantonale gewoonte in de federale wet.',
    ],
    [
      'Welk theoretisch kader boden vroege Zwitsers federalisme (na 1815) voor latere federale theorie?',
      [
        'Een model voor consociationalisme',
        'Zwitserland had geen theoretische invloed',
        'Federalisme stamt elders af',
        'Zwitsers model werd verworpen',
      ],
      0,
      'Zwitserlands federale compromis—dat kantonale diversiteit beschermde—werd een sjabloon voor consociationaal bestuur in multinationale staten.',
    ],
    [
      'Hoe compliceerde Zwingli\'s dood bij Kappel (1531) de voortgang van de gereformeerde theologie?',
      [
        'Zijn dood fragmenteerde hervorming',
        'Zwingli overleefde de oorlog',
        'Zijn dood verenigde alle hervormers',
        'Hij bekeerde tot katholicisme',
      ],
      0,
      'Zwingli\'s dood eindigde Zürichs militaire suprematie; Calvijns Genève bood een systematischere theologie, en verving daarmee Zwingli\'s civieke reformatie.',
    ],
  ],
  professor: [
    [
      'Hoe problematiseert het Brunner-Gilomen revisionistische raamwerk de teleologie van "Zwitserse unificatie" als coherent nationalisme van 1291?',
      [
        'Een retroactief 19de-eeuws construct',
        'Het traditionele narratief is onproblematisch',
        'Unificatie vond onmiddellijk in 1291 plaats',
        'Zwitserland werd nooit geünificeerd',
      ],
      0,
      'Moderne historiografie (Brunner, Gilomen) verwerpt het lineaire unificatienarratief, en benadrukt contingentie en retroactieve natievorming via 19de-eeuwse media.',
    ],
    [
      'Wat was de historische functie van de Rütli Eed-legende inzake Tschudi\'s en Simler\'s kronieken en Zwitserse identiteitsvorming?',
      [
        'Confessionele propaganda',
        'De eed was historisch nauwkeurig',
        'Het had geen identiteitsfunctie',
        'Het werd in de 19de eeuw uitgevonden',
      ],
      0,
      'Tschudi en Simler verankerden 16de-eeuwse religieuze geschillen in een veronderstelde "oude Zwitserse vrijheid"—Rütli diende als mythisch oorsprongspunt.',
    ],
    [
      'Hoe structureerden de "Allianties van Wederzijdse Verdediging" (Schützbünde) pre-1291 regionale competitie versus confederatienarratief?',
      [
        'Een pact, later gemythologiseerd',
        'Schützbünde waren uniek aan Zwitserland',
        'Ze bestonden niet',
        'Ze verenigden alle kantons',
      ],
      0,
      'Wederzijdse verdedigingspacten waren alomtegenwoordig in middeleeuws Europa; Zwitserse historiografie mystificeerde dit tot een uitzonderlijk oprichtingsnarratief.',
    ],
    [
      'Wat openbaart de vertraagde formalisering van confederatiestructuur (13 kantons niet tot 1513 vastgesteld)?',
      [
        'Miste coherente structuur eeuwenlang',
        'De confederatie werd formeel in 1291 geünificeerd',
        'Het formaliseerde nooit',
        'Het ontbond en hervormde continu',
      ],
      0,
      'Institutionele historici stellen vast dat de confederatie vaag bleef tot 1513; vroege kantons opereerden als onafhankelijke verbonden met beperkte consensus.',
    ],
    [
      'Hoe verhield Zwingli\'s eucharistietheologie zich tot zijn opkomende civieke magistraatstheorie?',
      [
        'Symbool spiegelde civiel bestuur',
        'Zwingli had geen politieke theorie',
        'Hij verwierp magistraten',
        'Hij was een katholieke theoloog',
      ],
      0,
      'Zwingli\'s symbolische eucharistietheologie spiegelde de civiel-magistrale ecclesiologie: beide hingen af van representatie in plaats van hiërarchische sacramentele macht.',
    ],
    [
      'Wat was de historiografische betekenis van Marburgs mislukking voor het gereformeerde protestantisme en de staatsvorming?',
      [
        'Kantons beslisten dogma, niet kerken',
        'Het verenigde alle gereformeerde kerken',
        'Het beëindigde gereformeerde theologie',
        'Het had geen betekenis',
      ],
      0,
      'Marburgs doctrinale mislukking verhinderde dat gereformeerde kerken één front vormden: kantonale heersers behielden hun eigen theologie, wat de kantonale onafhankelijkheid versterkte.',
    ],
    [
      'Hoe verklaart de mislukte juridische homogeniseringspoging van de Helvetische Republiek de daaropvolgende federalistische reactie (1815-1848)?',
      [
        'Kantonaal recht was te verankerd',
        'De republiek slaagde in homogenisatie',
        'Federalisten bevorderden verder centralisatie',
        'Geen reactie vond plaats',
      ],
      0,
      'De juridische centralisering van de Helvetische Republiek provoceerde kantonale tegenstand; de grondwetten van 1815 en 1848 bewaarden expliciet de kantonale juridische autonomie.',
    ],
    [
      'Wat was de rol van de Sonderbundoorlog (1847) in verhouding tot opkomend Zwitsers nationalisme versus Europees romantisme?',
      [
        'Het rechtvaardigde nationalisme',
        'Geen nationalisme ontstond',
        'Nationalisme ging al vooraf aan de oorlog',
        'Zwitserland bleef non-nationalistisch',
      ],
      0,
      'Na 1847 creëerden Zwitserse intellectuelen een nationalistisch narratief van federale moderniteit tegenover kantonaal obscurantisme, in contrast met het Europese nationalisme.',
    ],
    [
      'Wat was het historiografisch debat rond teruggang van Zwitsers huursoldatenwerk: technologische versus geopolitieke oorzaken?',
      [
        'Beide factoren telden',
        'Alleen technologie was belangrijk',
        'Alleen geopolitiek was belangrijk',
        'Huurlingenwerk daalde nooit',
      ],
      0,
      'Historici debatteren over de oorzaken van de teruggang van het huurlingenwerk: velen benadrukken de opkomst van permanente legers, anderen de relatieve vrede onder het Europese Concert.',
    ],
    [
      'Hoe vertegenwoordigde Alfred Escher\'s 1859 stichting Bundesbahn een theoretisch innovatieve federalistische integratieaanpak?',
      [
        'Hij zette federale infrastructuur door',
        'Spoorwegen hadden geen theoretisch belang',
        'Escher verzette zich tegen staatseigendom',
        'Spoorwegen waren kantonaal',
      ],
      0,
      'Eschers federale spoorweg vertegenwoordigde een innovatieve federale theorie: integratie via staatseigendom-infrastructuur die kantonale grenzen overstijgde.',
    ],
    [
      'Welk onopgelost historiografisch vraagstuk betreft verhouding 1874 burgerinitiatie tot Zwitserse Eurocepticisme?',
      [
        'Mogelijk een factor',
        'Ze zijn direct gerelateerd',
        'Ze zijn onafhankelijk',
        'Er bestaat geen vraag',
      ],
      0,
      'Geleerden debatteren of directe democratie Zwitserland via kantonale/volksveto\'s pathologisch predisponeerde tot Eurocepticisme, of dat dit een post-hocverklaring is.',
    ],
    [
      'Hoe verhield Artikel 47 van de Bankwet van 1934 zich tot de Zwitserse neutraliteitsideologie en het vermijden van sancties?',
      [
        'Het verhult dwang achter eenheid',
        'Bankgeheim voorkwam het omzeilen van sancties',
        'Het was onafhankelijk van neutraliteit',
        'Geheim werd nooit formaliseerd',
      ],
      0,
      'De timing van de Bankwet van 1934 (in het Volkenbond-tijdperk) weerspiegelt hoe Zwitserland bankgeheim strategisch als neutraliteitsinstrument inzette, wat het omzeilen van sancties mogelijk maakte.',
    ],
    [
      'Wat openbaart het historiografisch consociationalismeconcept (Lijphart op Zwitserland retroactief toegepast) en wat verbergt het?',
      [
        'Het verhult echte dwang achter consensus',
        'Consociatie verklaart volledig Zwitsers federalisme',
        'Het openbaart niets',
        'Het is anachronistisch',
      ],
      0,
      'Lijpharts consociale model belicht elite-accommodatie, maar vergeet dat de federalistische militaire overwinning van 1847 niet consensueel was; het compromis volgde op de nederlaag.',
    ],
    [
      'Hoe vormde het historiografisch debat "Zwingli als proto-nationalist" versus "civieke hervormer" moderne Zwitserse religieuze uitzonderlijkheid?',
      [
        'Het voedt het nationalisme-debat',
        'Er bestaat geen debat',
        'Alle historici zijn het erover eens dat hij een nationalist was',
        'Hij was niet civiek',
      ],
      0,
      'Historiografische Zwingli-lezing als nationalist versus institutionalist beïnvloedt hoe geleerden het multinationale karakter van modern Zwitserland framen; de spanning blijft onopgelost.',
    ],
    [
      'Wat openbaart de historiografische uitwissing van Geneefse en Vallaisgeschiedenis tot 1815 annexatie over retroactieve natiebouw?',
      [
        'Een 19de-eeuws construct',
        'Genève was altijd Zwitsers',
        'Valais was nooit Zwitsers',
        'Grenzen waren in 1291 vastgesteld',
      ],
      0,
      'Modern Zwitserlands grenzen zijn 1815-artefacten; de afwezigheid van Genève en Valais uit de pre-1815 Zwitserse historiografie openbaart nationale identiteit als een 19de-eeuws construct.',
    ],
  ],
};
